
/* styles */
require("!!vue-style-loader!css-loader!../node_modules/vue-loader/lib/style-rewriter?id=data-v-0a6d9ca4!sass-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./SexAge.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./SexAge.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-0a6d9ca4!../node_modules/vue-loader/lib/selector?type=template&index=0!./SexAge.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/SexAge.vue
// module id = 186
// module chunks = 0